import * as React from 'react'

import { Box, CollapsableCard, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import PanesHeader from 'modules/core/components/PanesHeader'
import Toggler from 'modules/core/components/Toggler'
import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import { automations } from 'modules/automations/store/collections/automations'
import type { Automation } from 'modules/automations/store/models/Automation'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

import Content from './Content'

interface CardProps {
  automation: Automation
}

const Card = ({ automation }: CardProps) => {
  return (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Box>
        <Text.Normal>{i18n.t('expenses.settings.approval.title')}</Text.Normal>
        <Text.Normal size="200">{i18n.t('expenses.settings.approval.description')}</Text.Normal>
      </Box>
      <Box>
        <Toggler active={automation.isEnabled} onChange={() => automation.toggleActivation()} />
      </Box>
    </Box>
  )
}

interface Props {
  addon: SubscriptionAddon
}

const ApprovalSettings = ({ addon }: Props) => {
  const { loading } = useUnsafeAsyncData(
    () =>
      automations.fetch({
        data: {
          billing_subscription_addon_id: addon.attributes.db_id,
          include_hidden: true,
        },
      }),
    [addon]
  )

  const automationsAvailable = !loading && !!automations

  return (
    <>
      <PanesHeader
        description="Expense approvals and approvals responsible"
        illustration="document-approved"
        line={false}
        title="Approval"
      />
      {loading && <Loading />}
      {automationsAvailable &&
        automations.map((automation) => (
          <CollapsableCard
            key={automation.attributes.id}
            open={automation.isEnabled}
            Card={<Card automation={automation} />}
            Content={<Content automation={automation} />}
          />
        ))}
    </>
  )
}

export default observer(ApprovalSettings)
